import { Button  } from "@mui/material";
import React from "react";
import "./FixtureStyles.scss";

interface GroupPanelProps {
  currentGroup: string;
  setCurrentGroup: React.Dispatch<React.SetStateAction<string>>;
}

const GroupPanel: React.FC<GroupPanelProps> = ({
  currentGroup,
  setCurrentGroup,
}) => {
  return (
    <div
      className="groupPanelScroll"
      style={{
        padding: "20px 20px 0 20px",
        display: "flex",
        justifyContent: "center",
        gap: "14px",
        width: "100%",
        flexWrap: "wrap",
      }}
    >
      {GROUPS.map((group, index) => (
        <GroupButton
          label={group}
          onClick={() => setCurrentGroup(group)}
          isActive={currentGroup === group}
          key={`groupButton- ${index}`}
        />
      ))}
    </div>
  );
};

export default GroupPanel;

export const GROUPS = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L"];

interface GroupButtonProps {
  label: string;
  onClick: React.Dispatch<React.SetStateAction<string>>;
  isActive: boolean;
}
const GroupButton: React.FC<GroupButtonProps> = ({
  label,
  onClick,
  isActive,
}) => {
  return (
    <Button
      className={`groupPanel__button${isActive ? " groupPanel__button--active" : ""}`}
      onClick={() => onClick(label)}
    >
      {label}
    </Button>
  );
};
